import React, { ReactNode, useEffect } from "react";

// third-party
import { IntlProvider } from "react-intl";

// project import
import useConfig from "../hooks/useConfig";

import messages_en from "../../src/utils/locales/en.json";
import messages_ar from "../../src/utils/locales/ar.json";
import { I18n } from "../types/config";

// ==============================|| LOCALIZATION ||============================== //

interface Props {
  children: ReactNode;
}

const Locales = ({ children }: Props) => {
  const { i18n } = useConfig();

  const messages = {
    ar: messages_ar,
    en: messages_en,
  };

  // Ensure i18n is a valid locale
  const currentLocale = i18n === "ar" || i18n === "en" ? i18n : "en";

  useEffect(() => {
    console.log("Current language:", currentLocale);
    console.log("Available messages:", messages[currentLocale]);
  }, [currentLocale]);

  return (
    <IntlProvider
      locale={currentLocale}
      defaultLocale="en"
      messages={messages[currentLocale]}
      onError={(err) => {
        if (err.code === "MISSING_TRANSLATION") {
          console.warn("Missing translation:", err.message);
          return;
        }
        throw err;
      }}
    >
      {children}
    </IntlProvider>
  );
};

export default Locales;
